import { Button, Modal, Text } from '@mantine/core';

interface DialogModalProps {
  cancelLabel?: string;
  close: () => void;
  confirmLabel?: string;
  message?: string;
  noCloseOverlay?: boolean;
  onClose?: (didConfirm: boolean) => void;
  opened: boolean;
  showCloseIcon?: boolean;
  title?: string;
}

export default function DialogModal({
  cancelLabel,
  close,
  confirmLabel,
  message,
  noCloseOverlay,
  onClose,
  opened,
  showCloseIcon,
  title,
}: DialogModalProps) {
  const handleOnClose = (didConfirm: boolean) => {
    onClose?.(didConfirm);
    close?.();
  };

  return (
    <Modal
      opened={opened}
      onClose={() => handleOnClose(false)}
      title={title}
      closeOnClickOutside={!noCloseOverlay}
      withCloseButton={showCloseIcon}
      data-testid="dialogModal"
    >
      {message && (
        <Text mb="24" variant="body-sm">
          {message}
        </Text>
      )}
      <Button fullWidth onClick={() => handleOnClose(true)}>
        {confirmLabel || 'Done'}
      </Button>
      {cancelLabel && (
        <Button mt="16" fullWidth variant="outline" onClick={() => handleOnClose(false)}>
          {cancelLabel}
        </Button>
      )}
    </Modal>
  );
}
